import { createAction, props } from '@ngrx/store';

import type { AssignDriver } from '../../models/assign-driver';
import type { Profile } from '../../models/profile';
import type { PricingSettings } from '../../models/settings';

// profile
export const setProfileImage = createAction(
  '[Views] Set Profile Image',
  props<{ image: File | string }>()
);

export const setProfile = createAction('[Views] Set Profile', props<{ profile: Profile }>());

export const loadPricingSettings = createAction('[Views] Load Pricing Settings');

// Success
export const loadPricingSettingsSuccess = createAction(
  '[Views] Load Pricing Settings Success',
  props<{ settings: PricingSettings }>()
);

// Failure (optional)
export const loadPricingSettingsFailure = createAction(
  '[Views] Load Pricing Settings Failure',
  props<{ error: string }>()
);

//toggle assign driver dialog on assign from booking management
export const openAssignDriver = createAction('[Assign Driver] Open');
export const closeAssignDriver = createAction('[Assign Driver] Close');
export const setAssignDriverBooking = createAction(
  '[Assign Driver] Set Booking',
  props<{ booking: AssignDriver }>()
);

// clear state
export const clearViewsState = createAction('[Views] Clear Views State');

// list tabs persistence
export const setSelectedListTab = createAction(
  '[Views] Set Selected List Tab',
  props<{ featureKey: string; tabKey: string | null }>()
);

export const resetSelectedListTabs = createAction('[Views] Reset Selected List Tabs');
